import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const HideDropDown = (props) => {
  const [hidden, setHidden] = useState([]);
  const [hiddenFilter, setHiddenFilter] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    const hideList = Array.isArray(props.columnsHide) ? props.columnsHide : [];
    const showList = Array.isArray(props.columnsShow) ? props.columnsShow : [];

    const mergedMap = new Map();
    [...hideList, ...showList].forEach((item) => {
      if (item) {
        const key = item.field || item.colId || item.headerName;
        if (key) {
          if (!mergedMap.has(key)) {
            mergedMap.set(key, item);
          }
        } else {
          mergedMap.set(Symbol(), item);
        }
      }
    });

    const merged = Array.from(mergedMap.values());
    merged.sort((a, b) => {
      const seqA = a.sequence ?? a.sequence_value ?? a.sequence_order ?? a.mapping_sequence_list;
      const seqB = b.sequence ?? b.sequence_value ?? b.sequence_order ?? b.mapping_sequence_list;
      const valA = seqA !== undefined && seqA !== null ? Number(seqA) : Infinity;
      const valB = seqB !== undefined && seqB !== null ? Number(seqB) : Infinity;
      return valA - valB;
    });

    setHidden(merged);
  }, [props.columnsHide, props.columnsShow]);

  useEffect(() => {
    if (value.trim()) {
      let newfilter = hidden.filter((item) =>
        item.headerName
          ? item.headerName.toLowerCase().includes(value.toLowerCase())
          : false
      );
      setHiddenFilter(newfilter);
    } else {
      setHiddenFilter([]);
    }

    if (!value.trim()) {
      setIsSearch(false);
    } else {
      setIsSearch(true);
    }
  }, [value, hidden]);

  const filterHiddenField = (evt) => {
    const { value } = evt.target;
    setValue(value);
  };

  const populateField = () => {

    const hiddenValues = (props.columnsHide || []).map(
      (item) => item?.field ?? item?.value ?? item
    );
    if (hiddenFilter.length > 0) {
      return hiddenFilter.map((check, index) => {
        const val = check?.field ?? check?.value ?? check;
        return (
          <div className="dropdown-item " key={index}>
            <span key={index}>
              <input
                type="checkbox"
                className="form-check-input"
                name={check.field}
                checked={hiddenValues.includes(val) ? false : true}
                onChange={props.inputChangeCheckbox}
              />
              {check.headerName}
            </span>
          </div>
        );
      });
    }
    return !isSearch ? (
      hidden.map((check, index) => {
        const val = check?.field ?? check?.value ?? check;
        return (
          <div className="dropdown-item " key={index}>
            <span key={index}>
              <input
                type="checkbox"
                className="form-check-input"
                name={check.field}
                checked={hiddenValues.includes(val) ? false : true}
                onChange={props.inputChangeCheckbox}
              />
              {check.headerName}
            </span>
          </div>
        );
      })
    ) : (
      <div className="dropdown-item">
        <span>No Data Found</span>
      </div>
    );
  };
  return (
    <div class="hide-area">
      <div class="dropdown">
        <div
          id="dropdownMenuReference"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          data-bs-reference="parent"
        >
          <OverlayTrigger
            key={"kanban"}
            placement={"top"}
            overlay={
              <Tooltip id={`manage-columns`}>
                <strong>Show/Hide Column</strong>
              </Tooltip>
            }
          >
            <span class="span-svg">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1249_27754)">
                  <path
                    d="M10.4649 10.465C9.46776 11.2251 8.25357 11.6462 6.99992 11.6667C2.91659 11.6667 0.583252 6.99999 0.583252 6.99999C1.30885 5.64777 2.31525 4.46635 3.53492 3.53499M5.77492 2.47333C6.17645 2.37934 6.58754 2.33236 6.99992 2.33333C11.0833 2.33333 13.4166 6.99999 13.4166 6.99999C13.0625 7.66243 12.6402 8.28609 12.1566 8.86083M8.23659 8.23666C8.07637 8.4086 7.88317 8.5465 7.66851 8.64215C7.45384 8.7378 7.22211 8.78923 6.98714 8.79337C6.75217 8.79752 6.51876 8.7543 6.30086 8.66628C6.08295 8.57826 5.88501 8.44726 5.71883 8.28108C5.55265 8.11491 5.42165 7.91696 5.33363 7.69905C5.24562 7.48115 5.20239 7.24775 5.20654 7.01277C5.21068 6.7778 5.26212 6.54607 5.35776 6.33141C5.45341 6.11674 5.59132 5.92354 5.76325 5.76333"
                    stroke="#202223"
                    stroke-opacity="0.5"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M0.583252 0.583344L13.4166 13.4167"
                    stroke="#202223"
                    stroke-opacity="0.5"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_1249_27754">
                    <rect width="14" height="14" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          </OverlayTrigger>
        </div>
        <div
          class="dropdown-menu dropdown-menu-start newfieldtogg"
          style={{
            minWidth: "184px",
            border: "none",
            boxShadow:
              "rgba(0, 0, 0, 0.06) 0px 16px 24px, rgba(0, 0, 0, 0.04) 0px 2px 6px, rgba(0, 0, 0, 0.04) 0px 0px 1px",
          }}
        >
          <div className="searchDropDown px-2">
            <input
              type="text"
              className="searchhiddenfield form-control"
              onChange={filterHiddenField}
              placeholder="Search..."
            />
          </div>
          {populateField()}
        </div>
      </div>
    </div>
  );
};

export default HideDropDown;
